// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// Import required modules
import { Pagination } from "swiper/modules";

export const Testimonials = () => {
  return (
    <section className="flat-spacing-1">
      <div className="container">
        <div className="flat-title wow fadeInUp" data-wow-delay="0s">
          <span className="title">Testimonials</span>
          {/* <p className="sub-title">
            Beat the Heat in Style: It's time to stock up on summer essentials!
          </p> */}
        </div>

        <div className="wrap-carousel">
          <Swiper
            spaceBetween={30}
            freeMode={true}
            pagination={{ clickable: true }}
            breakpoints={{
              1024: { slidesPerView: 3, spaceBetween: 30 }, // Desktop: 3 slides
              768: { slidesPerView: 2, spaceBetween: 15 }, // Tablet: 2 slides
              480: { slidesPerView: 1, spaceBetween: 15 }, // Mobile: 1 slide
            }}
            modules={[Pagination]}
            className="mySwiper"
          >
            {/* Testimonial 1 */}
            <SwiperSlide>
              <div
                className="testimonial-item style-column wow fadeInUp"
                data-wow-delay=".1s"
              >
                <div className="rating">
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                </div>
                <div className="heading">Great Selection and Quality</div>
                <div className="text">
                  "I love the variety of styles and the high-quality clothing on
                  this web fashion site."
                </div>
                <div className="author">
                  <div className="name">Allen Lyn</div>
                  <div className="metas">Customer from France</div>
                </div>
              </div>
            </SwiperSlide>

            {/* Testimonial 2 */}
            <SwiperSlide>
              <div
                className="testimonial-item style-column wow fadeInUp"
                data-wow-delay=".2s"
              >
                <div className="rating">
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                </div>
                <div className="heading">Best Customer Service</div>
                <div className="text">
                  "I finally found a web fashion site with stylish and
                  flattering options in my size."
                </div>
                <div className="author">
                  <div className="name">Peter Rope</div>
                  <div className="metas">Customer from USA</div>
                </div>
              </div>
            </SwiperSlide>

            {/* Testimonial 3 */}
            <SwiperSlide>
              <div
                className="testimonial-item style-column wow fadeInUp"
                data-wow-delay=".3s"
              >
                <div className="rating">
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                  <i className="icon-start"></i>
                </div>
                <div className="heading">Great Selection and Quality</div>
                <div className="text">
                  "I love the variety of styles and the high-quality clothing on
                  this web fashion site."
                </div>
                <div className="author">
                  <div className="name">Hellen Ase</div>
                  <div className="metas">Customer from Japan</div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>

          {/* Pagination */}
          <div className="sw-dots style-2 sw-pagination-testimonial justify-content-center"></div>
        </div>
      </div>
    </section>
  );
};
